import { api } from '@/core/helpers/axiosHelper';

export default {
   async get(resource_type_key: string, requires_resource_id: number) {
      return await api
         .get('/scope', {
            params: {
               'filter[resource_type_key]': resource_type_key,
               'fields[scopes]': 'key,name,description',
               'filter[requires_resource_id]': requires_resource_id,
               append: 'resource_type_scope_description',
            },
         })
         .then((response) => {
            return response?.data;
         });
   },
};
